import config from '../config';

import { getProductSizes } from '../app/services/product-type/ProductTypeService';
import apiRequest from './ApiService';

import { fetchUser } from '../app/config/ConfigActions';

const getFilterableProductSizes = (productSize, productTypeId) => {
  return productSize === 'ALL' ? getProductSizes(productTypeId).map((item) => item.id) : [productSize];
};

const getProductSizeParam = (productSize, productTypeId) => {
  const filteredParams = getFilterableProductSizes(productSize, productTypeId)
    .map((item) => encodeURIComponent(item))
    .join(',');

  return `productSize=${filteredParams}`;
};

const getProductTemplateParam = (template) => (template !== 'ALL' ? `template=${template}` : '');

const getProductSortParam = (productSort) => (productSort ? `sort=${productSort}` : '');

const getProductSearchParam = (searchTerm) => (searchTerm ? `query=${searchTerm}` : '');

const getApprovalStatusParam = (approvalStatus) => (approvalStatus ? `approvalStatus=${approvalStatus}` : '');

const getFilterParams = ({ template, productSort, searchTerm, productTypeId, productSize, approvalStatus }) => {
  const reqSearchTerm = getProductSearchParam(searchTerm);
  const reqProductSize = getProductSizeParam(productSize, productTypeId);
  const reqProductSort = getProductSortParam(productSort);
  const reqTemplate = getProductTemplateParam(template);
  const reqApprovalStatus = getApprovalStatusParam(approvalStatus);

  let params = reqTemplate;
  if (reqSearchTerm) {
    params += `&${reqSearchTerm}`;
  }
  if (reqProductSize) {
    params += `&${reqProductSize}`;
  }
  if (reqProductSort) {
    params += `&${reqProductSort}`;
  }
  if (reqApprovalStatus) {
    params += `&${reqApprovalStatus}`;
  }
  return params;
};

/**
 * Builds the URI according to the specified configuration
 * @param action Redux action
 * @param state Current state of the application
 * @returns {string} relative URI
 */
export const buildProductsURI = ({ action, user, productSettings }) => {
  let apiLink = action.url;
  let separator = apiLink.match(/\?/) ? '&' : '?';

  const { ids, excludedIds } = action;
  const { sendIds, sendPaging, sendFilters, sendStore } = action.urlConfig;

  if (ids !== undefined && ids.length > 0 && sendIds) {
    apiLink += `${separator}ids=${ids}`;
    separator = '&';
  }
  if (excludedIds !== undefined && excludedIds.length > 0 && !sendIds) {
    apiLink += `${separator}excludedIds=${excludedIds}`;
    separator = '&';
  }
  if (sendPaging !== false) {
    apiLink += `${separator}from=${productSettings.start || 0}&size=${config.page.products}`;
    separator = '&';
  }
  if (sendFilters !== false) {
    apiLink += `${separator}${getFilterParams(productSettings)}`;
    separator = '&';
  }
  if (sendStore === true) {
    apiLink += `${separator}storeCode=${user.selectedStoreCode}`;
  }
  return apiLink;
};

// Used by PACT
export const productsEndpointRequest = (apiUrl, action, user, productSettings) => {
  const url = buildProductsURI({ action, productSettings, user });
  return apiRequest({
    method: action.method,
    url: `${apiUrl}/${url}`,
  });
};

export const productsMiddlewareFactory = (apiUrl) => (store) => (next) => (action) => {
  if (action.type !== 'REQUEST_PRODUCTS') {
    return next(action);
  }

  const doFetchUser = fetchUser(apiUrl);
  const requestId = action.requestId || Math.floor(Math.random() * 10000000);
  return doFetchUser.then((user) => {
    const { productSettings } = store.getState();
    return productsEndpointRequest(apiUrl, action, user, productSettings)
      .then((response) => {
        if (!response.ok) {
          return action.callback({
            error: true,
            requestId,
            store,
            ids: action.ids,
            newRequest: !action.requestId,
          });
        }

        if (response.isRedirected) {
          return null;
        }
        return response.status === 204 ? {} : response.json();
      })
      .then((json) => {
        return (
          json &&
          action.callback({ store, requestId, ids: action.ids, newRequest: !action.requestId, jsonResponse: json })
        );
      });
  });
};
